//@flow
import {useEffect} from 'react';
import {useSelector} from 'react-redux';

import {actions} from './duck';
import {useActions} from '../../../utils/globalStore';
import {
  setGTMIntegrationService,
  getGTMIntegrationService,
  updateGTMIntegrationService,
  deleteGTMIntegrationService,
} from './promises';

import type {StoreAnalyticsProvider} from '../../../entities';
import type {RootState} from '../..';

const selectGoogleIntegrationInfo = (state: RootState) => ({
  gtmProvider: state.reports.gtmProvider,
  googleAnalyticsId: state.reports.trackingId,
});

export function useInitializeStoreGoogleIntegration() {
  const {setGTMId} = useActions(actions);

  useEffect(() => {
    getGTMIntegrationService().then(response => {
      setGTMId({
        id: response.measurementId,
        label: 'Google Tag Manager',
        provider: 'google-tag-manager',
        trackingId: response.measurementId,
        enabled: response.enabled,
      });
    });
  }, [setGTMId]);
}

export function useStoreGoogleIntegrationInfo(): {
  gtmProvider?: StoreAnalyticsProvider,
  googleAnalyticsId?: string,
} {
  const {gtmProvider, googleAnalyticsId} = useSelector(
    selectGoogleIntegrationInfo
  );

  return {
    gtmProvider,
    googleAnalyticsId,
  };
}

export function useStoreAnalyticsActions() {
  const {setGTMId} = useActions(actions);

  const createStoreGTM = (gtmId: string) => {
    return setGTMIntegrationService(gtmId).then(response => {
      setGTMId({
        id: response.measurementId,
        label: 'Google Tag Manager',
        provider: 'google-tag-manager',
        trackingId: response.measurementId,
        enabled: response.enabled,
      });
    });
  };

  const updateStoreGTM = (gtmId: string) => {
    return updateGTMIntegrationService({
      measurementId: gtmId,
      enabled: true,
    }).then(response => {
      setGTMId({
        id: response.measurementId,
        label: 'Google Tag Manager',
        provider: 'google-tag-manager',
        trackingId: response.measurementId,
        enabled: response.enabled,
      });
    });
  };

  const setEnabledGTM = (enabled: boolean) => {
    return updateGTMIntegrationService({enabled}).then(response => {
      setGTMId({
        id: response.measurementId,
        label: 'Google Tag Manager',
        provider: 'google-tag-manager',
        trackingId: response.measurementId,
        enabled: response.enabled,
      });
    });
  };

  const deleteStoreGTM = () => {
    return deleteGTMIntegrationService();
  };

  return {
    createStoreGTM,
    setEnabledGTM,
    updateStoreGTM,
    deleteStoreGTM,
  };
}
